module.exports = __webpack_public_path__ + "static/media/user_icon.baab7be6.svg";